import React from 'react';
import { USER_TYPE } from '@/shared/consts';
import { SignIn } from '../SignIn';
import { useTranslation } from 'react-i18next';

export const VendorSignIn: React.FC = () => {
  const { t } = useTranslation();
  return <SignIn userType={USER_TYPE.VENDOR}>{t('sign_in.vendor.content')}</SignIn>;
};
